import { nanoid } from 'nanoid';

/**
 * Generate a unique message ID.
 * Format: msg_{timestamp}_{randomId}
 *
 * Uses nanoid for collision-resistant random IDs.
 * Timestamp prefix aids debugging/sorting.
 */
export function generateMessageId() {
  return `msg_${Date.now()}_${nanoid(6)}`;
}
